import { useState, useRef, useEffect } from "react";
import { Auth, Hub } from "aws-amplify";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { userState } from "../../interface/MainInterface";

import Toast from "../../utils/Toast";
import { Typography } from "@mui/material";
import "./Signin.css";
import { useNavigate } from "react-router-dom";
const unAuthAPI = new HttpUnAuthApi();
interface propsType {
  userState: userState;
}

const SignIn = (props: propsType) => {
  let navigate = useNavigate();
  const toastRef: any = useRef();
  const userIdRef: any = useRef();
  const userPwdRef: any = useRef();
  const verifyCodeRef: any = useRef();
  const userPwdConfirmRef: any = useRef();

  const [userId, setUserId] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [userPwdConfirm, setUserPwdConfirm] = useState("");
  const [realId, setRealId] = useState("");
  const [realPwd, setRealPwd] = useState("");
  const [needConfirm, setNeedConfirm] = useState(false);
  const [needNewPwd, setNeedNewPwd] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");

  const listener = (data: any) => {
    if (data?.payload?.data?.code === "UserNotFoundException") {
      toastRef.current?.toast("User not found.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    } else if (data?.payload?.data?.code === "NotAuthorizedException") {
      toastRef.current?.toast(
        "Please check your email or password",
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
    } else if (data?.payload?.data?.code === "UserNotConfirmedException") {
      // 컨펌코드 넣기
      setNeedConfirm(true);
    } else if (data?.payload?.data?.code === "CodeMismatchException") {
      toastRef.current?.toast("Please check your verify code.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      verifyCodeRef.current.focust();
    } else {
      console.error(">>>>>> : " + data?.payload?.data);
    }
  };

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", listener);
    return unsubscribe;
  }, []);

  useEffect(() => {
    return () => {
      setUserId("");
      setUserPwd("");
      setUserPwdConfirm("");
      setNeedConfirm(false);
      setVerifyCode("");
      setRealId("");
      setRealPwd("");
    };
  }, []);

  const fnUserCount = async () => {
    const param: any = {
      command: "update_user_count",
      user_id: userId,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
    }
  };
  const fncSignIn = async () => {
    if (userId === "" || userId === undefined) {
      toastRef.current?.toast("Please enter your ID.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      userIdRef.current.focus();
      return;
    }
    if (userPwd === "" || userPwd === undefined) {
      toastRef.current?.toast("Please enter your password.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      userPwdRef.current.focus();
      return;
    }

    setRealId(userId);
    setRealPwd(userPwd);

    try {
      await Auth.signIn(userId, userPwd);
      //로그인 카운팅
      fnUserCount();
      toastRef.current?.toast("Welcome " + userId, "success", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      window.location.href = "/";
    } catch (error: any) {}
  };

  const autoSignIn = async () => {
    if (realId === "" || realId === undefined) {
      toastRef.current?.toast("Please enter your email.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      userIdRef.current.focus();
      return;
    }
    if (realPwd === "" || realPwd === undefined) {
      toastRef.current?.toast("Please enter your password.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      userPwdRef.current.focus();
      return;
    }

    try {
      await Auth.signIn(realId, realPwd);
      toastRef.current?.toast("Welcome " + realId, "success", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      window.location.href = "/myAccount";
    } catch (error: any) {}
  };

  const fncConfirm = async () => {
    if (verifyCode === "" || verifyCode === undefined) {
      toastRef.current?.toast("Please enter your verify code.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      verifyCodeRef.current.focust();
      return;
    }

    try {
      await Auth.confirmSignUp(realId, verifyCode);
      toastRef.current?.toast("Success verify.", "success", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      setNeedConfirm(false);
      autoSignIn();
    } catch (error: any) {
      toastRef.current?.toast("Invalid verify code.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      verifyCodeRef.current.focust();
    }
  };

  const fncResendCode = async () => {
    try {
      await Auth.resendSignUp(realId);
      toastRef.current?.toast("Send your verify code.", "success", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      verifyCodeRef.current.focust();
    } catch (err) {
      console.error("error resending code: ", err);
    }
  };

  const fncForgot = async () => {
    if (userId === "" || userId === undefined) {
      toastRef.current?.toast("Please enter your ID.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      userIdRef.current.focus();
      return;
    }

    setRealId(userId);
    setRealPwd(userPwd);

    try {
      await Auth.forgotPassword(userId);
      setNeedNewPwd(true);
      toastRef.current?.toast(
        "Send verify code to your email.",
        "success",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      verifyCodeRef.current.focust();
    } catch (err) {
      console.error(err);
    }
  };

  const fncNewPwd = async () => {
    if (verifyCode === "" || verifyCode === undefined) {
      toastRef.current?.toast("Please enter your verify code.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      verifyCodeRef.current.focust();
      return;
    }

    if (userPwd === "" || userPwd === undefined) {
      toastRef.current?.toast(
        "Please enter your new password.",
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      userPwdRef.current.focus();
      return;
    }
    if (userPwdConfirm === "" || userPwdConfirm === undefined) {
      toastRef.current?.toast(
        "Please enter new password again.",
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      userPwdConfirmRef.current.focus();
      return;
    }
    if (userPwd.length < 6) {
      toastRef.current?.toast(
        "Please enter password more than 6 char",
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      userPwdRef.current.focus();
      return;
    }
    if (userPwd !== userPwdConfirm) {
      toastRef.current?.toast(
        "Passwords do not match. (new & again)",
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      userPwdConfirmRef.current.focus();
      return;
    }

    setRealId(userId);
    setRealPwd(userPwd);

    try {
      const data = await Auth.forgotPasswordSubmit(realId, verifyCode, userPwd);
      toastRef.current?.toast(
        "Success change your new password",
        "success",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      setNeedConfirm(false);
      autoSignIn();
    } catch (err) {
      console.error(err);
    }
  };

  const handlePasswordEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") fncSignIn();
  };

  const handleVerifyCodeEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") fncConfirm();
  };

  return (
    <>
      <Box className="login-container">
        <Box className="login-section" component={"div"}>
          <Stack direction="row" spacing={27} sx={{ p: 5 }}>
            {needConfirm ? (
              <Stack direction="column" sx={{ justifyContent: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pb: 5,
                  }}
                >
                  <Typography variant="h4" sx={{ fontWeight: 900 }}>
                    이메일 인증
                  </Typography>
                </Box>
                <Stack
                  className="login-input-wrap"
                  spacing={0.5}
                  direction="column"
                >
                  <Typography className="login-input-txt">
                    인증번호 입력
                  </Typography>
                  <TextField
                    id="txtVerifyCode"
                    className="login-input"
                    inputRef={verifyCodeRef}
                    value={verifyCode}
                    placeholder="인증번호를 입력해주세요."
                    variant="outlined"
                    autoFocus
                    fullWidth
                    required
                    onChange={(e) => {
                      setVerifyCode(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      handleVerifyCodeEnter(e);
                    }}
                    type="search"
                    autoComplete="off"
                    inputProps={{ enterKeyHint: "Enter" }}
                    sx={{ width: "360px", height: "50px", borderRadius: 5 }}
                  />
                </Stack>
                <Box className="login-btn-wrap">
                  <Button onClick={fncConfirm} sx={{ fontSize: "16px" }}>
                    인증하기
                  </Button>
                </Box>
                <Button
                  sx={{ color: "#2a2a2a", fontWeight: 700, mt: "20px" }}
                  onClick={fncResendCode}
                >
                  인증번호 재발송
                </Button>
              </Stack>
            ) : needNewPwd ? (
              <Stack direction="column" sx={{ justifyContent: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pb: 5,
                  }}
                >
                  <Typography sx={{ fontWeight: 900, fontSize: "1.5rem" }}>
                    비밀번호 찾기
                  </Typography>
                </Box>
                <Stack
                  className="login-input-wrap"
                  spacing={0.5}
                  direction="column"
                >
                  <Typography className="login-input-txt">
                    인증번호 입력
                  </Typography>
                  <TextField
                    inputRef={verifyCodeRef}
                    id="txtVerifyCode"
                    className="login-input"
                    value={verifyCode}
                    placeholder="인증번호를 입력해주세요."
                    variant="outlined"
                    autoFocus
                    fullWidth
                    required
                    type="search"
                    autoComplete="off"
                    inputProps={{
                      enterKeyHint: "Enter",
                      style: { padding: "12px 16px 10px 16px" },
                    }}
                    onChange={(e) => {
                      setVerifyCode(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      handleVerifyCodeEnter(e);
                    }}
                    sx={{ width: "360px", height: "50px", borderRadius: 5 }}
                  />
                </Stack>
                <Stack
                  className="login-input-wrap"
                  spacing={0.5}
                  direction="column"
                >
                  <Typography className="login-input-txt">
                    변경할 비밀번호
                  </Typography>
                  <TextField
                    id="sighInPwd"
                    className="login-input"
                    inputRef={userPwdRef}
                    value={userPwd}
                    placeholder="새 비밀번호를 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="password"
                    autoComplete="current-password"
                    inputProps={{
                      autoComplete: "new-password",
                      enterKeyHint: "Enter",
                      style: { padding: "12px 16px 10px 16px" },
                    }}
                    onChange={(e) => {
                      setUserPwd(e.target.value);
                    }}
                  />
                </Stack>
                <Stack
                  className="login-input-wrap"
                  spacing={0.5}
                  direction="column"
                >
                  <Typography className="login-input-txt">
                    변경할 비밀번호 확인
                  </Typography>
                  <TextField
                    id="sighInPwdComfirm"
                    className="login-input"
                    inputRef={userPwdConfirmRef}
                    value={userPwdConfirm}
                    placeholder="새 비밀번호를 재입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="password"
                    autoComplete="current-password"
                    inputProps={{
                      autoComplete: "new-password",
                      enterKeyHint: "Enter",
                      style: { padding: "12px 16px 10px 16px" },
                    }}
                    onChange={(e) => {
                      setUserPwdConfirm(e.target.value);
                    }}
                  />
                </Stack>
                <Box className="login-btn-wrap">
                  <Button onClick={fncNewPwd} sx={{ fontSize: "16px" }}>
                    비밀번호 변경하기
                  </Button>
                </Box>
                <Button
                  sx={{ color: "#2a2a2a", fontWeight: 700, mt: "20px" }}
                  onClick={fncResendCode}
                >
                  인증번호 재발송
                </Button>
              </Stack>
            ) : (
              <Stack direction="column" sx={{ justifyContent: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    pb: 5,
                  }}
                >
                  <Stack direction="column" gap={2.5}>
                    <Typography
                      variant="h4"
                      sx={{ fontWeight: 700, fontSize: "1rem" }}
                    >
                      AI로 파악하는 오늘의 HOT 트렌드
                    </Typography>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        src="/images/bi-2x.png"
                        style={{ width: "120px", height: "47.56px" }}
                      />
                    </div>
                  </Stack>
                </Box>
                <Stack
                  className="login-input-wrap"
                  spacing={0.5}
                  direction="column"
                >
                  <Typography className="login-input-txt">아이디</Typography>
                  <TextField
                    id="signInUserId"
                    className="login-input"
                    inputRef={userIdRef}
                    value={userId}
                    placeholder="아이디를 입력해주세요."
                    variant="outlined"
                    autoFocus
                    fullWidth
                    required
                    autoComplete="on"
                    inputProps={{ style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                      setUserId(e.target.value);
                    }}
                    sx={{ width: "22rem", height: "50px", borderRadius: 5 }}
                  />
                </Stack>
                <Stack
                  className="login-input-wrap"
                  spacing={1}
                  direction="column"
                >
                  <Typography className="login-input-txt">비밀번호</Typography>
                  <TextField
                    id="signInPwd"
                    className="login-input"
                    inputRef={userPwdRef}
                    value={userPwd}
                    placeholder="패스워드를 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="password"
                    autoComplete="current-password"
                    inputProps={{ style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                      setUserPwd(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      handlePasswordEnter(e);
                    }}
                  />
                </Stack>
                <Box className="login-btn-wrap">
                  <Button onClick={fncSignIn} sx={{ fontSize: "16px" }}>
                    로그인
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  sx={{
                    display: "flex", // 부모 요소를 flexbox로 설정
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  gap={1}
                >
                  {/* <Button
                    sx={{ color: "#2a2a2a", fontWeight: 700, mt: "24px" }}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    회원가입하기
                  </Button> */}
                  {/* <div style={{ marginTop: "24px" }}> | </div> */}
                  {/* <Button
                    sx={{ color: "#2a2a2a", fontWeight: 700, mt: "24px" }}
                    onClick={fncForgot}
                  >
                    비밀번호찾기
                  </Button> */}
                </Stack>
              </Stack>
            )}
          </Stack>
        </Box>
        <Box className="image-section">
          <img src="/images/login-kv.png" className="intro-image" />
        </Box>
      </Box>
      <Toast ref={toastRef} />
    </>
  );
};

export default SignIn;
